export const getRsvpAnswers = (settings) => Array.isArray(settings?.answer_options) ? settings.answer_options : [
  { id: "yes", label: settings?.presentation?.yes_label || "Sim", value: settings?.yes_value ?? "Sim", counts_as_attendance: true },
  { id: "no", label: settings?.presentation?.no_label || "Não", value: settings?.no_value ?? "Não", counts_as_attendance: false },
];

export const rsvpLinkPlaceholder = (definitionId) => `{{rsvp_link_${definitionId}}}`;

// Validate reusable template source; delivered invitation URLs are generated later.
export function emailRsvpTemplateErrorCode(html) {
  const source = String(html || "");
  const remainder = source.replace(/\{\{rsvp_link_[A-Za-z0-9_-]{1,96}\}\}/g, "");
  if (/\{\{?\s*rsvp_link/i.test(remainder)) return "RSVP_TEMPLATE_PLACEHOLDER_INVALID";
  const candidates = [
    ...[...source.matchAll(/\b(?:href|src)\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/gi)]
      .map((match) => match[1] ?? match[2] ?? match[3]),
    ...[...source.matchAll(/https?:\/\/[^"'\s<>]+/gi)].map((match) => match[0]),
  ];
  for (const candidate of candidates) {
    const decoded = candidate.replace(/&amp;|&#0*38;|&#x0*26;/gi, "&")
      .replace(/&#(\d+);|&#x([\da-f]+);/gi, (entity, decimal, hex) => {
        const value = parseInt(decimal || hex, decimal ? 10 : 16);
        return value <= 0x10ffff ? String.fromCodePoint(value) : entity;
      });
    let url;
    try { url = new URL(decoded, "https://template.invalid"); } catch (_) { continue; }
    let path = url.pathname;
    try { path = decodeURIComponent(path); } catch (_) { /* Keep malformed paths visible to validation. */ }
    path = path.replace(/\/+$/, "").toLowerCase();
    if (/\/api\/event\/rsvp-preview(?:\/|$)/.test(path)) return "RSVP_TEMPLATE_PREVIEW_LINK";
    const confirmation = path.endsWith("/confirmacao-dados");
    const legacyRoot = !path && url.searchParams.has("token")
      && ["p", "user_id", "invitation", "confirmation_token"].some((key) => url.searchParams.has(key));
    if (!confirmation && !legacyRoot) continue;
    if (url.searchParams.has("invitation") || url.searchParams.has("confirmation_token")) {
      return "RSVP_TEMPLATE_CONTAINS_CREDENTIAL";
    }
    return "RSVP_TEMPLATE_LEGACY_LINK";
  }
  return null;
}

export function emailRsvpDefinitionIds(html) {
  const source = String(html || "");
  const ids = new Set([...source.matchAll(/\{\{rsvp_link_([A-Za-z0-9_-]{1,96})\}\}/g)].map((match) => match[1]));
  for (const [rawUrl] of source.matchAll(/https?:\/\/[^"' <]+\?[^"' <]+/gi)) {
    try {
      const url = new URL(rawUrl.replace(/&amp;/gi, "&"));
      const path = url.pathname.replace(/\/+$/, "");
      if (path && !path.endsWith("/confirmacao-dados")) continue;
      const payload = JSON.parse(atob((url.searchParams.get("p") || "").replace(/ /g, "+")));
      if (typeof payload.definition_id === "string") ids.add(payload.definition_id);
    } catch (_) { /* Unrelated links do not reference an RSVP. */ }
  }
  return [...ids];
}

export function emailTemplateUsesRsvp(template, definitionId) {
  return emailRsvpDefinitionIds(template?.html).includes(definitionId);
}

export function removeEmailRsvpLinks(html, definitionId) {
  const usesRsvp = (value) => emailTemplateUsesRsvp({ html: value }, definitionId);
  return String(html || "")
    .replace(/\s+(?:href|src)\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/gi,
      (attribute, doubleQuoted, singleQuoted, unquoted) => usesRsvp(doubleQuoted ?? singleQuoted ?? unquoted) ? "" : attribute)
    .replace(/https?:\/\/[^"' <]+\?[^"' <]+/gi, (url) => usesRsvp(url) ? "" : url)
    .split(rsvpLinkPlaceholder(definitionId)).join("");
}
